/* eslint-disable */
import { T, useTheme } from "../../../tokens";

/** Unified auth footer — all PublicShell + CustShell-minimal pages. */
export function AuthFooter({ dark }) {
  const th = useTheme(dark);
  return (
    <div
      style={{
        height: 32,
        flexShrink: 0,
        borderTop: `1px solid ${th.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 9,
        color: th.textMuted,
        background: th.surface,
        gap: 4,
      }}
    >
      ZiniHub©2026 Powered by <span style={{ color: T.brand }}>ziniz.online</span>
    </div>
  );
}

export function PublicShellLeft({ dark }) {
  return (
    <div
      style={{
        width: "44%",
        minWidth: 0,
        alignSelf: "stretch",
        background: `linear-gradient(135deg,${T.brand} 0%,${T.violet} 100%)`,
        padding: "24px 20px",
        display: "flex",
        flexDirection: "column",
        gap: 16,
        flexShrink: 0,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: 7,
            background: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: 700,
            color: "#fff",
          }}
        >
          Z
        </div>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#fff" }}>ZiniHub</span>
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: 12, minHeight: 0 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 600, color: "#fff", lineHeight: 1.3, marginBottom: 6 }}>
            Your businesses,
            <br />
            one hub.
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)", lineHeight: 1.6 }}>
            Manage stores, track orders, connect with customers — all in one place.
          </div>
        </div>
        {[
          ["🏪", "Multi-store management"],
          ["📦", "Unified order tracking"],
          ["💬", "WhatsApp-native"],
        ].map(([icon, label]) => (
          <div
            key={label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 7,
              background: "rgba(255,255,255,0.1)",
              borderRadius: 7,
              padding: "7px 10px",
            }}
          >
            <span style={{ fontSize: 12 }}>{icon}</span>
            <span style={{ fontSize: 11, color: "rgba(255,255,255,0.9)" }}>{label}</span>
          </div>
        ))}
        <div
          style={{
            marginTop: 4,
            padding: "9px 10px",
            background: "rgba(255,255,255,0.08)",
            borderRadius: 7,
            borderLeft: "3px solid rgba(255,255,255,0.4)",
          }}
        >
          <div style={{ fontSize: 9, color: "rgba(255,255,255,0.5)", marginBottom: 3 }}>Trusted by merchants</div>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>100+ hubs created</div>
        </div>
      </div>
    </div>
  );
}

/** Compact brand strip for mobile auth — replaces hidden left panel. */
export function PublicMobileBrand({ dark, variant = "admin" }) {
  const isCustomer = variant === "customer";
  return (
    <div
      style={{
        flexShrink: 0,
        background: `linear-gradient(135deg,${T.brand} 0%,${T.violet} 100%)`,
        padding: "14px 16px",
        display: "flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0,
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: isCustomer ? "50%" : 8,
          background: "rgba(255,255,255,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: isCustomer ? 18 : 14,
          fontWeight: 700,
          color: "#fff",
          flexShrink: 0,
        }}
      >
        {isCustomer ? "🤖" : "Z"}
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: "#fff", marginBottom: 2 }}>ZiniHub</div>
        <div style={{ fontSize: 10, color: "rgba(255,255,255,0.75)", lineHeight: 1.4 }}>
          {isCustomer ? "Discover stores, order, checkout — one app." : "Your businesses, one hub."}
        </div>
      </div>
    </div>
  );
}

/** PublicShell — split desktop, mobile brand strip, pinned auth footer, full canvas height. */
export function PublicAuthShell({ dark, viewport = "desktop", children }) {
  const mob = viewport === "mobile";
  const th = useTheme(dark);

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        background: th.bg,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: mob ? "column" : "row",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        {mob ? <PublicMobileBrand dark={dark} variant="admin" /> : <PublicShellLeft dark={dark} />}
        <div
          style={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            padding: mob ? "12px 14px" : "20px",
            boxSizing: "border-box",
            background: dark ? T.dCanvas : T.lCanvas,
          }}
        >
          <div style={{ width: "100%", maxWidth: mob ? "100%" : 420, minWidth: 0, margin: mob ? "0" : "0 auto", flex: 1, display: "flex", flexDirection: "column" }}>
            {children}
          </div>
        </div>
      </div>
      <AuthFooter dark={dark} />
    </div>
  );
}

/** CustShell-minimal — 50-50 split (same as PublicAuthShell). Customer variant for mobile brand. */
export function CustAuthShell({ dark, viewport = "desktop", children }) {
  const mob = viewport === "mobile";
  const th = useTheme(dark);

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        background: th.bg,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: mob ? "column" : "row",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        {mob ? <PublicMobileBrand dark={dark} variant="customer" /> : <PublicShellLeft dark={dark} />}
        <div
          style={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            padding: mob ? "12px 14px" : "20px",
            boxSizing: "border-box",
            background: dark ? T.dCanvas : T.lCanvas,
          }}
        >
          <div style={{ width: "100%", maxWidth: mob ? "100%" : 420, minWidth: 0, margin: mob ? "0" : "0 auto", flex: 1, display: "flex", flexDirection: "column" }}>
            {children}
          </div>
        </div>
      </div>
      <AuthFooter dark={dark} />
    </div>
  );
}
